import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PlanCard from '../../components/PlanCard';
import { colors, typography } from '../../styles';

const styles = css`
.DetailSection {
  background-position: center;
  background-size: cover;
  padding:60px 0;
  border-bottom:1px solid ${colors.color5};

  img {
    max-width: 100%;
  }
  .DetailSection_heading {
    text-transform: uppercase;
    font:700 24px/1.3 ${typography.Display};
    position: relative;
    text-align: center;
    margin:0;
    padding:0 0 30px 0;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    color: ${colors.color2};

    @media (min-width: 992px) {
      font:700 53px/1.3 ${typography.Display};
    }
    span {
      font-weight: 100;
      font-size:16px;
      color:${colors.color5};
    }
    strong {
      background:#222;
      width:40px;
      height:40px;
      font-size: 14px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      border-radius: 50%;
      margin:5px auto 0 auto;
    }
  }
  .DetailSection_heading_color1 {
    background: rgba(0,77,67,.8);
  }
  .DetailSection_heading_color2 {
    background: rgba(0,161,96,.8);
  }
}
`;

function CommunityDetailPlans({ plans }) {
  return (
    <div className={styles}>
      {
        plans.length > 0 &&
        <div className="DetailSection">
          <h3 className="DetailSection_heading" id="plans"><span>Available</span> Plans</h3>
          <div className="container">
            <div className="row py-5 justify-content-center">
              {
                orderBy(plans, 'name').map(plan => (
                  <div className="col-sm-12 col-xl-6" key={plan._id}>
                    <PlanCard plan={plan} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

CommunityDetailPlans.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  plans: true,
})(CommunityDetailPlans);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Plans.js